// Test accounts: 9876543210 is the login given to the Play Store reviewers,
// 1234567890 the in-house demo. Mirrors DEMO_MOBILES in the API
// (api/new/functions.js) — keep the two lists in step. For these numbers the app
// skips device binding (a reviewer uses any phone), never asks for an OTP (Meta
// bills per message, and the API refuses to send one) and does not require a
// password; the API signs them in on the mobile number alone.
export const DEMO_MOBILES = ['9876543210', '1234567890'];
export const DEMO_MOBILE = DEMO_MOBILES[0];
const ten = (m) => String(m || '').replace(/\D/g, '').slice(-10);
export const isDemoMobile = (m) => DEMO_MOBILES.includes(ten(m));
